<template>
  <transition-fade appear>
    <div
      v-if="song && song.publicUrl"
      class="flex items-center h-4 w-full text-player-control-default fill-current"
    >
      <button
        @click="$emit('update:playing', !playing)"
        :title="playing ? '&#9646;&#9646; Pauze' : '&#9654; Afspelen'"
        class="w-7 h-7 flex justify-center items-center rounded-full focus:outline-none text-player-icon bg-player-control-default hover:bg-player-control-darkened transition-colors duration-100"
      >
        <transition-fade appear>
          <svg
            v-if="playing"
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="19"
            viewBox="0 0 17 19"
            class="w-4 h-4 p-[2px] fill-current"
          >
            <path d="M0 0h6v19H0zM11 0h6v19h-6z" />
          </svg>
          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 11.81 11.81"
            class="w-10 h-10 fill-current"
          >
            <path
              d="M4.61,7.99c-.36.17-.65-.02-.65-.41v-3.35c0-.4.29-.58.65-.41l3.82,1.8c.36.17.36.44,0,.61l-3.81,1.77Z"
            />
          </svg>
        </transition-fade>
      </button>

      <progress-control
        :duration="duration"
        :currentTime="currentTime"
        @update:currentTime="seek"
        :muted="muted"
      />

      <volume-control
        :volume="volume"
        @update:volume="$emit('update:volume', $event)"
        :muted="muted"
        @update:muted="$emit('update:muted', $event)"
      />

      <audio
        ref="audio"
        :src="song.publicUrl"
        :muted="muted"
        :volume="volume / 100"
        @durationchange="duration = $refs.audio?.duration"
        @timeupdate="currentTime = $refs.audio?.currentTime"
        @ended="onEnded"
        class="hidden"
      />
    </div>
  </transition-fade>
</template>

<script>
import TransitionFade from "../../../../magic/TransitionFade.vue";
import ProgressControl from "./ProgressControl.vue";
import VolumeControl from "./VolumeControl.vue";

export default {
  name: "SongPlayer",
  components: {
    TransitionFade,
    ProgressControl,
    VolumeControl,
  },
  data() {
    return {
      currentTime: 0,
      duration: undefined,
    };
  },
  props: {
    song: {
      type: Object,
      default: null,
      validator: (song) => !song || Object.keys(song).includes("publicUrl"),
    },
    playing: {
      type: Boolean,
      default: false,
    },
    muted: {
      type: Boolean,
      default: false,
    },
    volume: {
      type: Number,
      default: 75,
      validator: (volume) => volume >= 0 && volume <= 100,
    },
  },
  watch: {
    async playing(playing) {
      if (playing) {
        try {
          await this.$refs.audio?.play();
        } catch (e) {
          if (e instanceof DOMException && e.name === "AbortError") {
            // Ignore. Happens when either `pause()` is triggered or navigation
            // occurs while the `play()` Promise has not yet been fulfilled.
            return;
          }

          throw e;
        }
      } else {
        this.$refs.audio?.pause();
      }
    },
    song() {
      // Reset the instance data.
      Object.assign(this.$data, this.$options.data.call(this));
    },
    currentTime() {
      this.$emit("update:currentTime", this.currentTime);
    },
  },
  mounted() {
    this.duration = this.$refs.audio.duration;
  },
  updated() {
    this.duration = this.$refs.audio.duration;
  },
  methods: {
    seek(currentTime) {
      this.$refs.audio && (this.$refs.audio.currentTime = currentTime);
    },
    onEnded() {
      this.seek(0);
      this.$emit("update:playing", false);
    },
  },
};
</script>
